import { Component, Input } from '@angular/core';
import {
  NavController,
  ModalController,
  Gesture,
  Events,
  Platform
} from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilsServiceProvider } from '../../providers/utils-service/utils-service';
import { ProfileServiceProvider } from '../../providers/profile-service/profile-service';
import { ToastServiceProvider } from '../../providers/toast-service/toast-service';
import { ShareServiceProvider } from '../../providers/share-service/share-service';
import { SocialSharing } from '@ionic-native/social-sharing';
import { AppSettings } from '../../app/app.settings';
import { RequestServiceProvider } from '../../providers/request-service/request-service';
import { MessageFactory } from '../../app/factories/message.factory';
import * as moment from 'moment';
import { animate, transition, trigger, style } from '@angular/animations';
import { LoaderServiceProvider } from '../../providers/loader-service/loader-service';
import * as _ from 'lodash';

const win: any = window;

@Component({
  selector: 'lubbu-ask',
  templateUrl: 'lubbu-ask.html',
  animations: [
    trigger('loveAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(0, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.3s', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class LubbuAskComponent {
  @Input() public item;
  @Input() isFriendPage: boolean;
  @Input() isPublicAsk: boolean;

  count: number = 0;
  private pressGesture: Gesture;
  colorBack: string;
  lovedToggleAnimation = false;
  private lovedLoading = false;
  user;
  addReply: boolean = false;
  lubbuForm: FormGroup;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public domSanitizer: DomSanitizer,
    public utilsService: UtilsServiceProvider,
    private profileSvc: ProfileServiceProvider,
    public toastService: ToastServiceProvider,
    public shareService: ShareServiceProvider,
    public requestService: RequestServiceProvider,
    public messageFactory: MessageFactory,
    public formBuilder: FormBuilder,
    public loaderService: LoaderServiceProvider,
    public events: Events,
    private socialSharing: SocialSharing,
    private platform: Platform
  ) {
    this.user = this.profileSvc.getUser(true);

    this.lubbuForm = this.formBuilder.group({
      reply: ['', Validators.required]
    });
  }

  ngOnInit() {
    let dateToProcess;

    if (this.item.segment === 'asks') {
      dateToProcess = 'created_at';
    } else if (this.item.segment === 'gifts') {
      dateToProcess = 'fulfillment_created_at';
    } else if (this.item.segment === 'thanks') {
      dateToProcess = this.item.thanks_created_at
        ? 'thanks_created_at'
        : 'fulfillment_created_at';
    } else {
      dateToProcess = 'created_at';
    }

    this.item.date = moment(this.item[dateToProcess]).fromNow();
    this.colorBack = this.randomColor();
    if (this.item.picture) {
      this.item.picture =
        this.item.picture + `&time=${Math.floor(Math.random() * 10000)}`;
    }

    if (this.item.avatar) {
      this.item.avatar =
        this.item.avatar + `&time=${Math.floor(Math.random() * 10000)}`;
    }
  }

  loadMessage() {
    if (this.item.title) {
      let letter = this.item.title.substring(0, 1);
      if (
        letter.toUpperCase() == 'A' ||
        letter.toUpperCase() == 'E' ||
        letter.toUpperCase() == 'I' ||
        letter.toUpperCase() == 'O' ||
        letter.toUpperCase() == 'U'
      ) {
        this.item.message = 'Asked for';
      } else {
        this.item.message = 'Asked for';
      }
    }
  }

  loadName() {
    if (this.item.fullName) {
      let name = this.item.fullName.split(' ')[0];
      if (name.substring(name.length - 1, 1).toUpperCase() == 'S') {
        this.item.buttonName = name + "'";
      } else {
        this.item.buttonName = name + "'s";
      }
    }
  }

  fullFill(item) {
    if (this.user) {
      if (item.status === 'FULFILLED') {
        this.toastService.show('This ask is already fulfilled');
      } else {
        let modal = this.modalCtrl.create(
          'FullFillModalPage',
          {
            item: Object.assign({}, item)
          },
          { cssClass: 'fulfilled-modal' }
        );
        modal.present();
      }
    } else {
      this.navCtrl.setRoot('WelcomePage');
    }
  }

  add(item) {
    if (this.user) {
      let modal = this.modalCtrl.create(
        'AddModalPage',
        {
          item: Object.assign({}, item)
        },
        {
          cssClass: 'add-modal'
        }
      );
      modal.onDidDismiss(data => {
        if (data) {
          let modalConfirmation = this.modalCtrl.create('ConfirmModalPage', {
            title: 'Asked and done!',
            descriptionStyle: 'ask'
          });
          modalConfirmation.present();
        }
      });
      modal.present();
    } else {
      this.navCtrl.push('SignInPage');
    }
  }

  profile(item) {
    if (this.user) {
      this.friendProfile(item);
    } else {
      this.navCtrl.push('SignInPage');
    }
  }

  /**
   * Love action
   *
   * @memberof LubbuAskComponent
   */
  love() {
    if (this.lovedLoading) {
      return;
    }
    this.item.liked_by_user === null ? this.addLove() : this.removeLove();
  }

  /**
   * Add love for single request
   *
   * @memberof LubbuAskComponent
   */
  addLove(): void {
    this.lovedToggleAnimation = true;
    this.lovedLoading = true;
    this.requestService.addLikeRequest(this.item.id).subscribe(
      () => {
        setTimeout(() => {
          this.lovedToggleAnimation = false;
        }, 1000);
        this.item.likes++;
        this.item.liked_by_user = 1;
        this.lovedLoading = false;
      },
      () => {
        this.lovedToggleAnimation = false;
        this.lovedLoading = false;
        this.toastService.show(this.messageFactory.getMessage('BACKEND_ERROR'));
      }
    );
  }

  /**
   * Remove love for single request
   *
   * @memberof LubbuAskComponent
   */
  removeLove(): void {
    this.lovedLoading = true;
    this.requestService.removeLikeRequest(this.item.id).subscribe(
      () => {
        this.item.likes--;
        this.item.liked_by_user = null;
        this.lovedLoading = false;
      },
      () => {
        this.lovedLoading = false;
        this.toastService.show(this.messageFactory.getMessage('BACKEND_ERROR'));
      }
    );
  }

  friendProfile(item) {
    if (this.isPublicAsk) {
      return;
    }
    if (item.profile_id === this.user.id) {
      if (_.get(this.navCtrl.parent)) {
        this.navCtrl.parent.select(4);
      }
    } else {
      this.navCtrl.push('FriendProfilePage', { profileId: item.profile_id });
    }
  }

  shareAlert(item) {
    let link = window.location.hostname;
    if (link === 'localhost' || AppSettings.isSandbox) {
      link = 'dev-lubbu.abbit.io';
    } else if (AppSettings.isApp) {
      link = 'ask.lubbu.com';
    }

    const linkData = {
      canonicalIdentifier: `publicAsk/${item.id}`,
      canonicalUrl: `https://${link}/#/asks/${item.id}`,
      title: item.title,
      channel: 'facebook',
      contentDescription: item.comment,
      contentImageUrl: item.photo_url,
      data: {
        canonicalIdentifier: `publicAsk/${item.id}`,
        canonicalUrl: `https://${link}/#/asks/${item.id}`,
        title: item.title,
        contentDescription: item.comment,
        contentImageUrl: item.photo_url,
        $og_title: item.title,
        $og_description: item.comment,
        $og_image_url: item.photo_url
      }
    };

    const shareService = this.shareService;
    const socialSharing = this.socialSharing;
    const utilsService = this.utilsService;

    win.branch.link(linkData, function(err, link) {
      if (err === null) {
        if (utilsService.isDevice) {
          socialSharing.share(link, 'Lubbu');
        } else {
          shareService.presentShare('Lubbu', link, 'Lubbu');
        }
      }
    });
  }

  /**
   * Generate random color
   *
   * @returns {string}
   * @memberof LubbuAskComponent
   */
  randomColor() {
    const o = Math.round;
    const r = Math.random;
    const s = 255;
    return `rgba(${o(r() * s)}, ${o(r() * s)}, ${o(r() * s)},${0.5})`;
  }

  ngOnDestroy(): void {
    if (this.pressGesture) {
      this.pressGesture.destroy();
    }
  }

  /**
   * Open modal to remove ask
   *
   * @param {Object} item
   * @memberof LubbuAskComponent
   */
  removeAsk(item) {
    let modal = this.modalCtrl.create('RemoveAskModalPage', { item });
    modal.present();
  }

  /**
   * Edit Ask
   *
   * @param {Object} item
   * @memberof LubbuAskComponent
   */
  editAsk(item) {
    if (this.user) {
      let modal = this.modalCtrl.create(
        'AddModalPage',
        {
          item: Object.assign({}, item),
          buttonLabel: 'SAVE'
        },
        {
          cssClass: 'add-modal'
        }
      );
      modal.present();
    } else {
      this.navCtrl.push('SignInPage');
    }
  }

  /**
   * Thanks Ask
   *
   * @param {Object} item
   * @memberof LubbuAskComponent
   */
  thanks(item) {
    let modal = this.modalCtrl.create(
      'ThanksModalPage',
      { item: item },
      {
        cssClass: 'thanks-modal'
      }
    );

    modal.onDidDismiss(data => {
      if (data) {
        this.navCtrl.setRoot('FriendProfilePage', {
          profileId: data,
          from: 'PassAlongModalPage'
        });
      }
    });
    modal.present();
  }

  /**
   * Add reply thank
   *
   * @memberof LubbuAskComponent
   */
  addReplyMessage(id) {
    this.loaderService.showLoader();
    this.requestService
      .addThanksReply(id, this.lubbuForm.get('reply').value)
      .subscribe(
        () => {
          this.loaderService.dismissLoader();
          this.events.publish('fulfill-item');
        },
        () => {
          this.loaderService.dismissLoader();
          this.toastService.show(
            this.messageFactory.getMessage('BACKEND_ERROR')
          );
        }
      );
  }
  /**
   * Go to thanks tab and scroll to anchor id
   *
   * @memberof LubbuAskComponent
   */
  gotoThanksSegment(): void {
    this.navCtrl.push('FriendProfilePage', {
      profileId: this.item.fulfillment_profile_id,
      fulfillmentId: this.item.id
    });
  }

  getBgImage(brandName) {
    return brandName !== 'adidas'
      ? `./assets/partner-logos/${brandName}.png`
      : './assets/partner-logos/adidas-logo.png';
  }
}



// WEBPACK FOOTER //
// ./src/components/lubbu-ask/lubbu-ask.ts